<template>
  <div class="progress-bar" v-if="typeof this.questions != 'undefined'">
      <span v-for="(value, index) in questions" v-bind:key="index" class="step" :class="value"></span>
  </div>
</template>

<script>

export default {
  name: 'Progress-Bar',
  props: ['questions']
}
</script>
